import { MapContainer, TileLayer, Circle, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Clock3 } from "lucide-react";
import { ZONES } from "../lib/zones";

const MAP_CENTER = [51.048, -114.08];
const MAP_STYLE = { height: "560px", width: "100%" };
const LIVE_PATH = { color: "#10B981", fillColor: "#10B981", fillOpacity: 0.25, weight: 2 };
const SOON_PATH = { color: "#042F1E", fillColor: "#042F1E", fillOpacity: 0.06, weight: 1.5, dashArray: "6 6" };
const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

const ZonePopup = ({ zone }) => (
  <>
    <span className="font-syne text-sm font-bold text-forest">{zone.name}</span>
    <br />
    {zone.live ? (
      <span className="inline-flex items-center gap-1 text-xs font-semibold text-forest/70">
        <Clock3 className="h-3 w-3 text-fresh" /> Delivering in {zone.eta}
      </span>
    ) : (
      <span className="text-xs font-semibold text-forest/60">Coming soon</span>
    )}
  </>
);

export const ZoneMapCanvas = ({ mapRef, onSelect }) => (
  <div
    data-testid="zone-map"
    className="overflow-hidden rounded-[2.5rem] border border-forest/10 shadow-[0_40px_80px_-40px_rgba(4,47,30,0.35)]"
  >
    <MapContainer ref={mapRef} center={MAP_CENTER} zoom={12} scrollWheelZoom={false} style={MAP_STYLE}>
      <TileLayer attribution={OSM_ATTRIBUTION} url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {ZONES.map((z) => (
        <Circle
          key={z.name}
          center={z.pos}
          radius={900}
          pathOptions={z.live ? LIVE_PATH : SOON_PATH}
          eventHandlers={{ click: () => onSelect(z.name) }}
        >
          <Popup>
            <ZonePopup zone={z} />
          </Popup>
        </Circle>
      ))}
    </MapContainer>
  </div>
);
